import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const AccountancyCareerSkills = () => {
  return (
    <CareerSkillsSection
      title="ACCOUNTANCY SKILLS? CHECK."
      paragraphs={[
        `In Accountancy at JRIIT, you'll get an education built on core programs that are vital for success in today's financial world — expertise in accounting principles, financial analysis, auditing, and tax management. These are the skills that employers say make JRIIT Accountancy graduates stand out. Our Accountancy program offers both a 1-year Certificate for foundational skills and a 2-year Diploma for advanced specialization in financial management.`,

        `Why? We emphasize hands-on learning instead of traditional letter grades. In every course, you'll receive detailed feedback on your accounting strengths and where you can improve, giving you a more complete picture of your growth.`,

        `Discover our Accountancy programs below and unlock the skills to shape your future.`,
      ]}
    />
  );
};

export default AccountancyCareerSkills;
